/**
 * DWEEB logo mark — inlined from dweeb.faizo.net's favicon (same author).
 * Used wherever RoleLogic links out to the DWEEB webhook-message builder.
 */
export function DweebMark({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      role="img"
      aria-label="DWEEB"
      className={className}
    >
      <rect width="512" height="512" rx="112" fill="#5865F2" />
      <rect x="40" y="210" width="52" height="30" rx="15" fill="#fff" />
      <rect x="420" y="210" width="52" height="30" rx="15" fill="#fff" />
      <rect x="214" y="200" width="84" height="30" rx="15" fill="#57F287" />
      <rect x="78" y="182" width="148" height="148" rx="46" fill="#fff" />
      <rect x="286" y="182" width="148" height="148" rx="46" fill="#fff" />
      <path
        d="M226 360 h28 v24 a12 12 0 0 1 -12 12 h-4 a12 12 0 0 1 -12 -12 z"
        fill="#fff"
      />
      <path
        d="M258 360 h28 v24 a12 12 0 0 1 -12 12 h-4 a12 12 0 0 1 -12 -12 z"
        fill="#fff"
      />
    </svg>
  );
}

export default DweebMark;
